<template>
  <detail-page-layout :config="pageConfig" class="EntrustDetail">
    <el-table :loading="IsLoading" element-loading-text="加载中" :data="[DataDetail]">
      <el-table-column label="委托单" prop="Code"></el-table-column>
      <el-table-column label="客户订单号" prop="ReferenceCode">
      </el-table-column>
      <el-table-column label="委托类型">
        <template scope="props">
            <el-col>{{props.row.DelegationType | DelegationType}}</el-col>
          </template>
      </el-table-column>
    </el-table>
    <h3 style="line-height: 3em;">物料清单</h3>
    <el-table :loading="IsLoading" element-loading-text="加载中" :data="DataDetail.Lines">
      <el-table-column type="expand">
        <template scope="props">
          <el-form  inline class="demo-table-expand">
            <el-form-item label="客户物料名称：">
              <span>{{props.row.CustomerProductName | NullShow}}</span>
            </el-form-item>
            <el-form-item label="客户物料编码：">
              <span>{{props.row.CustomerProductCode | NullShow}}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="物料名称/编码" width="260px">
        <template scope="props">
            <el-col>{{props.row.Product.Name}}</el-col>
            <el-col>物料编码:{{props.row.Product.Code}}</el-col>
          </template>
      </el-table-column>
      <el-table-column label="品项">
        <template scope="props">
            <el-tag :type="props.row.Condition.Name | ConditionColor">{{props.row.Condition.Name}}</el-tag>
          </template>
      </el-table-column>
      <el-table-column label="品牌" prop="Product.Brand.Name"></el-table-column>
      <el-table-column label="机型" prop="Product.Model.Name"></el-table-column>
      <el-table-column label="模块" prop="Product.Module.Name"></el-table-column>
      <el-table-column label="数量" prop="Quantity"></el-table-column>
      <el-table-column label="委托时长" >
        <template scope="props">
          <el-col>{{props.row.DelegationPeriodDays}}天</el-col>
        </template>
      </el-table-column>
      <el-table-column label="报价" >
        <template scope="props">
          <el-col>{{props.row.DelegationUnitPrice | amount}}</el-col>
        </template>
      </el-table-column>
    </el-table>
  </detail-page-layout>
</template>

<script>
import DetailPageLayout from '@/components/common/DetailPageLayout'
import o from '@/odata'
export default {
  created() {
    this.getDataDetail()
  },
  data() {
    return {
      DataDetail: {},
      pageConfig: {
        StepsBarEnabled: true,
        Steps: [
          {key: 'receiving', title: '待确认'},
          {key: 'finished', title: '已确认'},
        ],
        Step: 1,
        Breadcrumbs: [
          {
            to: {name: 'EntrustOrder'},
            name: '委托申请单列表',
          },
        ],
      },
      defaultSteps: [
        {key: 'receiving', title: '待确认'},
        {key: 'finished', title: '已确认'},
      ],
      IsLoading: false,
    }
  },
  methods: {
     /* 获取订单详情 */
    getDataDetail() {
      this.IsLoading = true
      const id = this.$route.params.id
      o('DelegationRequest').find(id).expand('Partner($select=Id,Code,Name)').expand('Lines($expand=Product,Condition)')
      // .expand(`Partner($select=Id,Code,Name)`).expand('Lines($expand=Lots($expand=Lot),Province,City,County)')
        .get()
        .then(({ data }) => {
          this.IsLoading = false
          this.DataDetail = data
          this.updateSteps(data.State)
        }).catch((err) => {
          this.IsLoading = false
          let message
          switch (err.status) {
            case 404:
              message = '订单不存在'
              break
            default:
              message = `unkown error${err.status}`
          }
          this.$alert(message, 'Error!')
        })
    },
    updateSteps(State) {
      switch (State) {
        case 'draft':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 1)
          break
        case 'confirmed':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 2)
          break
        case 'cancelled':
          this.$set(this.pageConfig, 'Steps', [this.defaultSteps[0], { key: 'fail', title: '已取消', state: 'failure' }])
          this.$set(this.pageConfig, 'Step', 2)
          break
      }
    },
  },
  components: {
    DetailPageLayout,
  },
}
</script>
<style lang="less" scoped>
.EntrustDetail{
  .demo-table-expand {
      font-size: 0;
      padding-bottom:10px;
      margin-bottom:10px;
  }
  .table-data{
    border-bottom: 1px solid #ccc;
  }
  .demo-table-expand label {
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 20%;
  }
  .status{
    color: red;
  }
  .el-form-item__content{
    line-height: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// EntrustDetail_order.vue?1840e41c